import React from "react";

import i18next from "external/i18n";

export const ActualContent = () => (
  <>
    <p>{i18next.t("help.claim.content.actual.content.paragraph")}</p>
  </>
);
